import { useCallback } from 'react';
import { selectSalaryBands, useAppInitStore } from '../../stores';

export const useSalaryBands = () => {
	const salaryBands = useAppInitStore(selectSalaryBands);

	const getSalaryBandById = useCallback(
		(salaryBandId: number) => salaryBands.find((r) => r.id === salaryBandId),
		[salaryBands]
	);

	return { salaryBands, getSalaryBandById };
};
